<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <input
      type="number"
      min="1"
      step="1"
      :id="id"
      :readonly="readonly"
      v-model="value"
      :placeholder="entity.description"
      :name="name"
      :required="required"
      :maxlength="maxlength"
      :autocomplete="name"
    />
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";

export default {
  mixins: [Field],
  methods: {
    typecast(value) {
      return value ? parseFloat(value) : null;
    },
  },
};
</script>

<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// number-field.vue?16d271ca